import $ from 'jquery';
/**
 * Enables the "navigation bar" functionality.
 */
const enableNavigationBarFunctionality = () => {
    if ($('#navigation-bar').length === 0) {
        return;
    }
    /**
     * The current path.
     */
    const currentPath = _trimQuerystring(window.location.pathname);
    /**
     * Whether dropdown menus should be displayed when its associated link is hovered.
     */
    let hoverDropdowns = false;
    /**
     * The navigation links that can trigger a dropdown menu.
     */
    const $navLinkDropdowns = $('#navigation-bar .nav-link.dropdown-toggle');
    // Handles the toggling of the dropdown menus
    $navLinkDropdowns.each(function () {
        const $navLink = $(this);
        const $dropdownMenu = $navLink.siblings('.dropdown-menu');
        let timer;
        // Prevents the navigation link from toggling the menu
        $navLink.on('click', (e) => {
            e.preventDefault();
        });
        // Displays the associated dropdown menu and hides the others
        $navLink.on('mouseover', () => {
            clearTimeout(timer);
            _hideOtherDropdowns($navLink);
            _toggleDropdown($navLink, true);
        });
        // Hides the associated dropdown menu after a timeout
        $navLink.on('mouseout', () => {
            timer = window.setTimeout(() => {
                _toggleDropdown($navLink, false);
            }, 500);
        });
        // Displays the dropdown menu and hides the others
        $dropdownMenu.on('mouseover', () => {
            clearTimeout(timer);
            _hideOtherDropdowns($navLink);
            _toggleDropdown($navLink, true);
        });
        // Hides the dropdown menu after a timeout
        $dropdownMenu.on('mouseout', () => {
            timer = window.setTimeout(() => {
                _toggleDropdown($navLink, false);
            }, 500);
        });
    });
    // Add animation to dropdown when expanding
    $('.dropdown').on('show.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });
    // Add animation to dropdown when collapsing
    $('.dropdown').on('hide.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
    });
    // Create a handler for when the min-width of the viewport changes
    const matchBreakpoint = window.matchMedia('(min-width: 1200px)');
    matchBreakpoint.addEventListener('change', (e) => {
        _toggleDropdownLinks(e.matches);
    });
    // Determine whether dropdown menus are initially displayed via hover or click
    _toggleDropdownLinks(matchBreakpoint.matches);
    // Highlight the link in the navigation bar that corresponds to the current path
    $('#navigation-bar .nav-link, #mobile-navigation-bar .nav-link').each(function () {
        const $link = $(this);
        if (currentPath === _trimQuerystring($link.attr('href') || '')) {
            $link.addClass('active');
        }
        $link.siblings('.dropdown-menu').children('.dropdown-item').each(function () {
            const $dropdownItem = $(this);
            if (currentPath === _trimQuerystring($dropdownItem.attr('href') || '')) {
                $dropdownItem.addClass('active');
            }
        });
    });
    /**
     * Hides all dropdown menus other than the given link.
     * @param $link - The link.
     */
    function _hideOtherDropdowns($link) {
        $navLinkDropdowns.each(function () {
            const $navLink = $(this);
            if ($navLink.attr('id') !== $link.attr('id')) {
                _toggleDropdown($navLink, false);
            }
        });
    }
    /**
     * Toggles whether a dropdown menu is displayed.
     * @param $link - The link associated with the dropdown menu.
     * @param show - Whether the dropdown menu is displayed.
     */
    function _toggleDropdown($link, show) {
        if (!hoverDropdowns) {
            return;
        }
        const $dropdown = $link.siblings('.dropdown-menu');
        $dropdown.parent().toggleClass('show', show);
        $dropdown.toggleClass('show', show);
        $link.attr('aria-expanded', show.toString());
        $link.toggleClass('hover', show);
    }
    /**
     * Toggles whether the dropdown menus are displayed via hover (desktop) or click (mobile).
     * @param hover - Whether the menus should be displayed via hover.
     */
    function _toggleDropdownLinks(hover) {
        $navLinkDropdowns.each(function () {
            const navLinkDropdown = $(this);
            if (hover) {
                navLinkDropdown.removeAttr('role');
                navLinkDropdown.removeAttr('data-toggle');
                hoverDropdowns = true;
            }
            else {
                navLinkDropdown.attr('role', 'button');
                navLinkDropdown.attr('data-toggle', 'dropdown');
                hoverDropdowns = false;
            }
        });
    }
    /**
     * Trims a URL of its query string.
     * @param url - The URL.
     * @returns The trimmed URL.
     */
    function _trimQuerystring(url) {
        return url.replace(/\?.*$/, '');
    }
};
export default enableNavigationBarFunctionality;
